import { diffJson } from "diff";
import Log from "./log";

function storageAvailable(type) {
  let storage;
  try {
    storage = window[type];
    let x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0)
    );
  }
}

function isDifferent(former, current) {
  return diffJson(former.data, current).length !== 1;
}

export function filterOutExpiredBackups(storage) {
  try {
    let freshBackups = [];
    let backups = JSON.parse(storage.getItem("backups"));
    if (backups && backups.revisions && backups.revisions.length > 0) {
      freshBackups = backups.revisions.filter(revision => {
        if (revision.time) {
          return Date.now() - revision.time <= 604800000;
        } else return false;
      }); // 1 week 604800000
    }
    return freshBackups;
  } catch (e) {
    /* eslint-disable no-console */
    Log.log(e);
  }
}

export function storeLocalBackup(state) {
  let backups,
    storage,
    backupString,
    revision,
    revisions,
    lastRevision,
    newRevision;

  if (storageAvailable("localStorage") === true) {
    storage = window.localStorage;
  } else {
    Log.log(storageAvailable("localStorage"));
    return;
  }
  try {
    let freshBackups = filterOutExpiredBackups(storage);
    if (freshBackups.length > 0) {
      backups = {
        revisions: freshBackups,
      };
      storage.setItem("backups", JSON.stringify(backups));
    }

    backupString = storage.getItem("backups");

    if (backupString) {
      backups = JSON.parse(backupString);
      revisions = backups["revisions"];
      newRevision = {
        time: Date.now(),
        data: state,
      };
      if (revisions.length >= 5) {
        if (isDifferent((lastRevision = revisions.pop()), state)) {
          revisions.shift();
          revisions.push(lastRevision);
        }
      }
      revisions.push(newRevision);
      storage.setItem("backups", JSON.stringify(backups));
    } else {
      backups = {
        revisions: [],
      };
      revision = {
        time: Date.now(),
        data: state,
      };
      backups["revisions"].push(revision);
      storage.setItem("backups", JSON.stringify(backups));
    }
  } catch (e) {
    Log.log(e.name);
  }
}

export function logLocally(msg, key) {
  if (storageAvailable("localStorage") === true) {
    let storage = window.localStorage;
    try {
      const k = key || Date.now();
      storage.setItem(k, msg);
      return true;
    } catch (e) {
      Log.log(e.name);
      return false;
    }
  } else {
    Log.log(storageAvailable("localStorage"));
    return false;
  }
}
